exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/core-js/library/modules/_object-gops.js
// module id = ../../../../core-js/library/modules/_object-gops.js
// module chunks = 42